import React, { useState } from "react";
import { Stack, Text } from "@fluentui/react";
import AuditFilters from "@/components/audits/AuditFilters";
import {
  AuditFilter,
  IAuditFilter,
  filterAuditRecords,
  AuditRecord,
} from "@/api/audits";
import AuditDetailList from "@/components/audits/AuditDetailList";
import ShimmerList from "@/ui-controls/ShimmerList";
import AuditDetailsPanel from "@/components/audits/AuditDetailsPanel";

interface Props {}

const Audits = (props: Props) => {
  const [auditRecords, setAuditRecords] = useState<AuditRecord[]>([]);
  const [selectedAuditRecord, setSelectedAuditRecord] = useState<
    AuditRecord | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const performFilterAuditRecords = (filter: AuditFilter) => {
    setIsLoading(true);

    if (!filter.canFilter()) {
      setAuditRecords([]);
      setIsLoading(false);
      return;
    }

    filterAuditRecords(filter).then(
      (result) => {
        setAuditRecords(result);
        setIsLoading(false);
      },
      (error: Error) => {
        setIsLoading(false);
        handleError(error);
      }
    );
  };

  const handleError = (error: Error) => {
    // Error handling would go here in real app
  };

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { padding: "16px" } }}>
      <Text variant="xLarge" styles={{ root: { fontWeight: 600 } }}>
        Authorization Audits
      </Text>
      <AuditFilters
        onChangeFilters={(filter) =>
          performFilterAuditRecords(new AuditFilter(filter))
        }
      />
      {isLoading ? (
        <ShimmerList numberOfColumns={6} />
      ) : (
        <div>
          <AuditDetailsPanel
            record={selectedAuditRecord}
            onClosePanel={() => setSelectedAuditRecord(undefined)}
          />
          <AuditDetailList
            AuditList={auditRecords}
            onSelectionChanged={setSelectedAuditRecord}
          />
        </div>
      )}
    </Stack>
  );
};

export default Audits;
